import type { LucideProps } from "lucide-react";
import { Check } from "lucide-react";

export type CheckIconProps = LucideProps;

export const CheckIcon = (props: CheckIconProps) => <Check {...props} />;

export default CheckIcon;
